
import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

export default function Header() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Products', path: '/products' },
    { name: 'Services', path: '/services' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className="relative w-14 h-14 flex items-center justify-center bg-gradient-to-br from-orange-500 via-orange-600 to-orange-700 rounded-xl shadow-lg">
              {/* Crown on top */}
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                <i className="ri-vip-crown-fill text-2xl text-yellow-400" style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))' }}></i>
              </div>
              {/* MB Letters */}
              <div className="text-white font-bold text-xl tracking-tight" style={{ fontFamily: '"Playfair Display", serif' }}>
                MB
              </div>
            </div>
            <div className="flex flex-col">
              <span className="text-2xl font-bold text-gray-800 leading-tight" style={{ fontFamily: '"Playfair Display", serif' }}>Malik Brothers</span>
              <span className="text-xs text-orange-600 font-semibold tracking-wide">Quality & Trust</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-orange-600'
                    : 'text-gray-700 hover:text-orange-600'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Contact Button */}
          <div className="hidden lg:block">
            <a
              href="tel:03135224547"
              className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              <i className="ri-phone-line text-lg"></i>
              0313-5224547
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`text-base font-semibold py-2 transition-colors cursor-pointer ${
                    location.pathname === link.path
                      ? 'text-orange-600'
                      : 'text-gray-700 hover:text-orange-600'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="tel:03135224547"
                className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-3 rounded-lg font-semibold transition-all text-center whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
              >
                <i className="ri-phone-line text-lg"></i>
                0313-5224547
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
